import { useUserContext } from '../../providers';
import { MyProfile } from './my-profile';
import { PublicProfile } from './PublicProfile';

export const ProfileRoute = () => {
  const { isCurrentUser } = useUserContext();

  return isCurrentUser ? <MyProfile /> : <PublicProfile />;
};
